var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{class:_vm.classes,style:(_vm.styles),attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('v-icon',{class:_vm.classes,staticStyle:{"vertical-align":"top"},style:(_vm.styles),attrs:{"x-small":""}},[_vm._v("mdi-open-in-new")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }